package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.list

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.rippleEffect
import org.hs_soft.runmynesto.domain.config.transitionColor
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.RestaurantProject
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.pages.components.Separator
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.hs_soft.runmynesto.pages.components.checkout.getArrowImg
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun ProjectItem(
    model: RestaurantProject?,
    windowSizeMode: WindowSizeModeEnum,
    projectItemIsSelected: Boolean,
    isExpandAll: Boolean,
    content: @Composable () -> Unit,
    onProjectItemClick: (RestaurantProject?) -> Unit,
)
{
    val isExpanded= remember{ mutableStateOf(isExpandAll) }
    LaunchedEffect(isExpandAll){
        isExpanded.value=isExpandAll
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .cursor(Cursor.Pointer)
            .onClick {
                event: SyntheticMouseEvent -> event.stopPropagation()
            },
        horizontalAlignment = Alignment.End
    ) {
        Row(
            modifier = Modifier
                .rippleEffect {
                    onProjectItemClick(model)
                    isExpanded.value=!isExpanded.value
                }
                .fillMaxWidth()
                .padding(leftRight = Dimen.normalPadding)
                .borderBottom(
                    color = Theme.ActionDisabledBackground.rgb,
                    width = Dimen.smallThickness,
                    style = LineStyle.Solid,
                )
                .boxShadow(color = Theme.ActionDisabledBackground.rgb)
                .height(Dimen.checkOutItemHeight),
            verticalAlignment = Alignment.CenterVertically
        )
        {

            VectorIcon(
                modifier = Modifier
                    .margin(left = Dimen.extraLargePadding),
                pathData = Res.PathIcon.restaurantIcon,
                color = Theme.TextDisabled.hex,
                height =Dimen.normalIconSize ,
                width =Dimen.normalIconSize ,
            )

            SpanText(
                text = model?.caption?:"",
                modifier = Modifier
                    .margin(left = Dimen.normalPadding)
                    .fontWeight(FontWeight.Medium)
                    .fontFamily(FontFamily.Jakarta)
                    .fontSize(FontSizes.mediumFontSize )
                    .transitionColor()
                    .color(
                        if (projectItemIsSelected) Theme.PrimaryMain.rgb
                        else Theme.TextPrimary.rgb
                    ),
            )

            Spacer()

            VectorIcon(
                modifier = Modifier
                    .onClick {

                    },
                width = Dimen.mediumIconSize,
                height = Dimen.mediumIconSize,
                pathData= getArrowImg(expanded = isExpanded.value),
                color = Theme.ActionActive.hex
            )

        }

        if (isExpanded.value){
            Column(
                modifier = Modifier
                    .padding(left = Dimen.mediumPadding)
                    .fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                content()
            }
        }

        if (isExpanded.value)
            Separator(  )


    }


}